export default __webpack_public_path__ + "static/media/problema-06.02e40bc8.webp";